/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { ReactElement, ReactNode } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text, BrandColors, MaterialIcon, Header } from '@blend/enterprise-components';

export const styles = StyleSheet.create({
  closingTitle: {
    minWidth: 80,
  },
  infoItem: {
    marginRight: 8,
  },
  infoRow: {
    alignItems: 'center',
    display: 'flex',
    ':not(:last-child)': {
      marginBottom: 8,
    },
  },
});

export namespace RoomInfoRow {
  export interface Props {
    id?: string;
    iconType?: MaterialIcon.Props['type'];
    rowHeader: string;
    rowInfo?: string | ReactElement;
    rowAction?: ReactNode;
  }
}

export const RoomInfoRow: React.FC<RoomInfoRow.Props> = ({ id, rowHeader, rowInfo, iconType, rowAction }) => {
  return (
    <div id={id} className={css(styles.infoRow)}>
      {iconType && (
        <div className={css(styles.infoItem)}>
          <MaterialIcon color={BrandColors.NIGHT} size={24} type={iconType} />
        </div>
      )}
      <div className={css(styles.closingTitle)}>
        <Header size={5}>{rowHeader}</Header>
      </div>
      <div>
        <Text data-it="RoomInfoRow-info">{rowInfo}</Text>
        {rowAction}
      </div>
    </div>
  );
};
